<template>
  <footer id="footer">
    <div class="footerMenu">
      <div class="footerLogo menuItem">
        <div class="bumibutuhaksi-logo"></div>
        <div class="clogo">
          <img class="logo-gp" src="../assets/logo-gp.png">
          <img src="../assets/logo-akarumput.png">
          <img src="../assets/logo-enter.png">
          <img src="../assets/logo-koprol.png">
          <img src="../assets/logo-solgen.png">
        </div>
      </div>
      <div class="menuItem">
        <ul>
          <li><router-link to="/bumi-kini#articles">Bumi Kini</router-link></li>
          <li><router-link to="#">Krisis Iklim</router-link></li>
          <li><router-link to="#">Faktor - Faktor</router-link></li>
          <li><router-link to="#">Dampak demi Dampak</router-link></li>
          <li><router-link to="#">Upaya ke Upaya</router-link></li>
        </ul>
      </div>
      <div class="menuItem">
        <ul>
          <li><router-link to="/bicara-bumi#articles">Bicara Bumi</router-link></li>
          <li><router-link to="#">Kabar dan Berita</router-link></li>
          <li><router-link to="#">Insight</router-link></li>
          <li><router-link to="#">Events / Discussions</router-link></li>
          <li><router-link to="/kelas-iklim">Curhat Iklim</router-link></li>
        </ul>
      </div>
      <div class="menuItem">
        <ul>
          <li><router-link to="#">Sumber dan Materi</router-link></li>
          <li><router-link to="#">Articles</router-link></li>
          <li><router-link to="#">Infographics</router-link></li>
          <li><router-link to="#">Videos</router-link></li>
          <li><router-link to="/kelas-iklim">Kelas Iklim</router-link></li>
          <li><router-link to="#">Sosial Media</router-link></li>
          <li><router-link to="#">Jejaring</router-link></li>
        </ul>
      </div>
      <div class="menuItem">
        <ul>
          <li><router-link to="/beraksi">Beraksi</router-link></li>
          <li><router-link to="#">Aksi Individu</router-link></li>
          <li><router-link to="#">Volunteering</router-link></li>
          <li><router-link to="#">Petisi</router-link></li>
          <li><router-link to="#">Jadwal Aksi</router-link></li>
          <li><router-link to="#">Donasi</router-link></li>
        </ul>
      </div>
    </div>
    <div class="copyright">
      <div class="container">
        <div class="socialMedia">
          <a href="https://www.instagram.com/bumibutuhaksi.id/"
            target="_blank" title="Instagram bumibutuhaksi.id"
            class="sm smIg"></a>
          <a href="https://www.youtube.com/user/GreenpeaceIndonesia"
            target="_blank" class="sm smYt"></a>
          <a href="https://www.facebook.com/GreenpeaceIndonesia"
            target="_blank" class="sm smFb"></a>
          <a href="https://www.tiktok.com/@bumibutuhaksi?"
            target="_blank" class="sm smTk"></a>
          <a href="https://twitter.com/GreenpeaceID"
            target="_blank" class="sm smTw"></a>
        </div>
        <div class="divider"></div>
        <div class="menuItem">
          <a href="https://www.greenpeace.org/indonesia/kebijakan-privasi/">Kebijakan Privasi</a>
        </div>
        <div class="menuItem">
          <a href="https://www.greenpeace.org/indonesia/hak-cipta/">Hak Cipta</a>
        </div>
        <div class="menuItem">
          <a href="https://www.greenpeace.org/indonesia/tentang-kami/">Hubungi Kami</a>
        </div>
        <div class="menuItem">
          &copy; {{y}} Bumi Butuh Aksi.
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      detail: null,
      solutions: [],
      pages: [],
      y: '',
    };
  },
  mounted() {
    const d = new Date();
    this.y = d.getFullYear();
  },
};
</script>

<style scoped lang="scss">
footer{
  position: relative;
  z-index: 9;
  background-color: #292A28;
  overflow: hidden;
  .socialMedia{
    position: relative;
    display: flex;
    .sm{
      width: 30px;
      height: 30px;
      display: block;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      cursor: pointer;
      margin-right: 20px;
      opacity: .7;
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        opacity: 1;
      }
      &.smFb{
        background-image: url("../assets/icon/Logo FB (Hover State)@2x.png");
      }
      &.smIg{
        background-image: url("../assets/icon/Logo IG (Hover State)@2x.png");
      }
      &.smYt{
        background-image: url("../assets/icon/Logo YT (Hover State)@2x.png");
        width: 38px;
      }
      &.smTk{
        background-image: url("../assets/icon/Logo Tiktok (Hover State)@2x.png");
      }
      &.smTw{
        background-image: url("../assets/icon/Logo TW (Hover State)@2x.png");
        width: 33px;
      }
    }
  }
  .footerMenu{
    color: #eee;
    display: flex;
    padding: 80px 30px;
    position: relative;
    max-width: 1600px;
    margin: 0 auto;
    &:before{
      background-image: url(../assets/forest.png);
      background-position: bottom center;
      background-size: contain;
      background-repeat: no-repeat;
      width: 80px;
      height: 80px;
      display: block;
      position: absolute;
      right: 40px; bottom: -100px;
      content: "";
      filter: invert(1);
      opacity: .1;
      @media (max-width: 980px) {
        display: none;
      }
    }
    .footerLogo{
      .bumibutuhaksi-logo{
        background-image: url(../assets/logo-white.png);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: left center;
        margin: 0 0 10px;
        height: 120px;
        opacity: .7;
      }
      .clogo{
        @media (max-width: 980px) {
          text-align: center;
        }
        img{
          height: 30px;
          margin-right: 16px;
          margin-bottom: 10px;
          @media (max-width: 980px) {
            margin-left: 16px;
          }
          &.logo-gp{
            height: 20px;
            margin-bottom: 13px;
          }
        }
      }
      .gp-logo{
        height: 24px;
        background-image: url(../assets/gp-logo-white.svg);
        background-size: contain;
        background-position: 12px 50%;
        background-repeat: no-repeat;
        margin-bottom: 20px;
        opacity: .7;
      }
    }
    .menuItem{
      width: 20%;
      &.footerLogo{
        width: 40%;
        @media (max-width: 1024px) {
          width: 30%;
        }
      }
      h4{
        font-weight: normal;
        text-transform: uppercase;
        font-size: 12px;
        color: #999;
      }
      ul{
        margin: 0;
        padding: 0;
        li{
          list-style: none;
          font-size: 14px;
          margin: 0 0 10px;
          line-height: 1.5;
          cursor: pointer;
          padding-right: 20px;
          a{
            color: #ccc;
            text-decoration: none;
            &:hover{
              color: #fff;
            }
          }
        }
      }
    }
    @media (max-width: 980px) {
      flex-wrap: wrap;
      padding: 30px 16px 10px;
      .menuItem{
        width: 50%;
        word-break: break-word;
        margin-bottom: 30px;
        &.footerLogo{
          width: calc(100% + 32px);
          margin: 0 -16px 40px;
          padding: 0 6px 20px;
          border-bottom: rgba(255,255,255,.1) 1px solid;
          .bumibutuhaksi-logo{
            height: 90px;
            background-position: center;
            margin-bottom: 0;
          }
          .gp-logo{
            height: 20px;
            background-position: center;
          }
        }
        ul{
          li{
            font-size: 13px !important;
            font-weight: normal;
            padding-right: 10px;
            margin-bottom: 4px;
            text-align: center;
          }
        }
      }
    }
  }
  .copyright{
    padding: 0 30px 60px;
    color: #ccc;
    font-size: 14px;
    .container{
      display: flex;
      white-space: nowrap;
      justify-content: center;
      align-items: center;
      @media (max-width: 980px) {
        display: block;
      }
      .divider{
        width: 100%;
        border-bottom: #999 1px solid;
        height: 1px;
        margin-left: 200px;
        @media (max-width: 1200px) {
          margin: 0;
        }
        @media (max-width: 980px) {
          display: none;
        }
      }
      .menuItem{
        margin-left: 40px;
        font-size: 13px;
        a{
          color: #ccc;
          text-decoration: none;
          transition: all .3s ease;
          &:hover{
            color: #fff;
          }
        }
      }
    }
    @media (max-width: 980px) {
      border-top: rgba(255,255,255,.1) 1px solid;
      padding: 20px;
      .socialMedia{
        justify-content: center;
        margin-bottom: 20px;
        .sm{
          margin: 0 12px;
        }
      }
      .menuItem{
        margin: 0 0 4px !important;
      }
    }
  }
}
</style>
